import React, { useState } from 'react';
import './app.css'
import 'antd/dist/antd.css';
import {BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Vote from './pages/vote/Vote'
import LandingPage from './pages/landingpage/LandingPage';
import Portal from './pages/portal/Portal';
import LogIn from './pages/login/LogIn';
import SignUp from './pages/signup/SignUp';

export interface Poll {
  "question": string,
  "options": string[],
  "deadline": Date,
  "voter_emails": string[]
}

export interface LoginUser {
  username: string,
  password: string
}

const App: React.FC = () => {
  const [requestUrl, setRequestUrl] = useState('https://fairvote-kbuqsc2ymq-ey.a.run.app')

  if(!requestUrl) {
    setRequestUrl('https://fairvote-kbuqsc2ymq-ey.a.run.app')
  }

  const refreshRequestBody = {
    method: 'POST',
    headers : {
        'Content-Type': 'application/json',
    },
    body : JSON.stringify({
        refresh : window.localStorage.getItem('refresh')
    })
}

  return (
    <Router>
      <Routes>
        <Route path='/' element={<LandingPage/>} />
        <Route path='/signup' element={<SignUp requestUrl={requestUrl}/>} />
        <Route path='/login' element={<LogIn requestUrl={requestUrl}/>} />
        <Route path='/portal' element={<Portal requestUrl={requestUrl} refreshRequestBody={refreshRequestBody}/>} />
        <Route path='/vote/:id' element={<Vote requestUrl={requestUrl}/>} />
      </Routes>
    </Router>
  );
}

export default App;